export enum NewsletterSubscriberStatus {
  SUBSCRIBED = "subscribed",
  UNSUBSCRIBED = "unsubscribed",
  /** Hard bounce reported by the provider; permanently excluded from sends. */
  BOUNCED = "bounced",
  /** Marked as spam by the recipient; permanently excluded from sends. */
  COMPLAINED = "complained",
}

export enum NewsletterReleaseStatus {
  DRAFT = "draft",
  SCHEDULED = "scheduled",
  SENDING = "sending",
  SENT = "sent",
  FAILED = "failed",
}

export enum NewsletterDeliveryStatus {
  SENT = "sent",
  FAILED = "failed",
}

export enum NewsletterContentMode {
  BLOCKS = "blocks",
  HTML = "html",
}

export enum NewsletterEventType {
  OPEN = "open",
  CLICK = "click",
}

export enum NewsletterBlockType {
  HEADING = "heading",
  TEXT = "text",
  LIST = "list",
  QUOTE = "quote",
  BUTTON = "button",
  IMAGE = "image",
  DIVIDER = "divider",
  SPACER = "spacer",
}
